export type { WorkingHoursProps } from "./working-hours";
export { WorkingHours } from "./working-hours";
